import ThreeSixtyView from './threeSixtyView/threeSixtyView';
import FallBack from './fallBack/fallBack';

window.ThreeSixtyView = ThreeSixtyView;
window.FallBack = FallBack;
